// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.askai_maindiv {
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 2rem;
    margin: 4rem; */
    /* background: #031B34;
    background: -moz-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);
    background: -webkit-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);
    background: -o-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);
    background: -ms-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);
    background: radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); */
}

/* Chat start*/
.chat_container {
    width: 100%;
    /* overflow-y: auto; */
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    max-height: 100%;
    /* background-color: white; */
}
.ai_send_btn {
    transition: 1s ease-out;


}

.ai_send_btn:hover {
    color: rgb(96, 96, 235);
    scale: 0.8;
}


.userBG {
    /* background: linear-gradient(89.97deg, #ff803b 1.84%, #7523ce 90.67%); */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background: none;
}

.chatgptBG {
    background: #053e7a;
}

.askai_chat_img {

    /* border-radius: 50%; */
}

.askai_chat_img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.askai_chat_desc {
    /* display: flex;
    align-items:end; */
    /* padding: 5px 0 0 0; */
    /* padding-top: 10px; */
}

.askai_chat_desc p {
    font-size: 1rem;
    font-weight: 400;
    color: #fff;
    margin-top: 20px;
    /* padding: 6px; */
}

/* For WebKit browsers (Chrome, Safari) */





/* chat end */


/* Typing container styling */
/* .typing-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    background: #031B34;
    border-top: 1px solid rgb(48, 50, 68);
} */

.typing-content {
    padding: 20px 10px;
    /* margin: 0 2rem; */
}

/* .typing-textarea {
    width: 100%;
    display: flex;
} */

/* .typing-textarea {
    resize: none;
    height: auto;
    border: none;
    padding: 10px 20px;
    color: #FFFFFF;
    font-size: 1rem;
    border-radius: 4px;
    max-height: 250px;
    overflow-y: auto;
    background: #053e7a;
    outline: 1px solid #053e7a;
} */

/* .textarea_form {
    width: 100%;
} */

/* .typing-textarea textarea::placeholder {
    color: #dcdcdc;
} */

.ai_parent {
    /* border-top-right-radius: 50%;
    border-bottom-left-radius: 50%; */
    border-radius: 30px 0 30px 0;
    border: .1rem solid rgb(255, 255, 255);
}

.ai_parent>::-webkit-scrollbar {
    width: 6px;
    /* Adjust to your preferred width */

}

.ai_parent>::-webkit-scrollbar-thumb {
    background: #6db4ff;


}







.typing-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* font-size: 1.4rem; */
    background: #053e7a;
    /* outline: 1px solid #053e7a; */
    cursor: pointer;
}

.typing-controls span:hover {
    background: #053e7a;
    color: #dcdcdc;
}

/* Reponsive Media Query */
@media screen and (max-width: 600px) {
    .typing-container {
        padding: 15px 10px;
    }

    /* .typing-textarea textarea {
        height: 45px;
        padding: 10px 40px 10px 10px;
    } */



    span.material-symbols-rounded {
        font-size: 1.25rem !important;
    }
}



/* Typing Animation */
.chat-bubble {
    background-color: #E6F8F1;
    padding: 16px 28px;
    -webkit-border-radius: 20px;
    -webkit-border-bottom-left-radius: 2px;
    -moz-border-radius: 20px;
    -moz-border-radius-bottomleft: 2px;
    border-radius: 20px;
    border-bottom-left-radius: 2px;
    display: inline-block;
}

.typing {
    align-items: center;
    display: flex;
    height: 17px;
}

.typing .dot {
    animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
    background-color: #FFFFFF;
    border-radius: 50%;
    height: 7px;
    margin-right: 4px;
    vertical-align: middle;
    width: 7px;
    display: inline-block;
}

.typing .dot:nth-child(1) {
    animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
    animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
    animation-delay: 400ms;
}

.typing .dot:last-child {
    margin-right: 0;
}

@keyframes mercuryTypingAnimation {
    0% {
        transform: translateY(0px);
        background-color: #053e7a;
    }

    28% {
        transform: translateY(-7px);
        background-color: #053e7a;
    }

    44% {
        transform: translateY(0px);
        background-color: #053e7a;
    }
}


@media only screen and (max-width: 600px) {
    .askai_maindiv {
        height: 100%;
        padding: 0;
        margin: 0;
    }
    .chat_container {
        max-height: 100px;
        margin: 0;
        padding: 0;
    }
    .askai_chat{
        padding: 0;
        margin: 0;
        gap: 0;
    }
    .typing-content{
        padding: 0;
        margin: 0;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AI/AskAI/AskAI.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;mBACe;IACf;;;;;;2DAMuD;AAC3D;;AAEA,cAAc;AACd;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,uBAAuB;;;AAG3B;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;;AAGA;IACI,0EAA0E;IAC1E,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;sBACkB;IAClB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yCAAyC;;;;;;AAMzC,aAAa;;;AAGb,6BAA6B;AAC7B;;;;;;;;GAQG;;AAEH;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;IACI;qCACiC;IACjC,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,mCAAmC;;AAEvC;;AAEA;IACI,mBAAmB;;;AAGvB;;;;;;;;AAQA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI;QACI,kBAAkB;IACtB;;IAEA;;;OAGG;;;;IAIH;QACI,6BAA6B;IACjC;AACJ;;;;AAIA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,sCAAsC;IACtC,wBAAwB;IACxB,kCAAkC;IAClC,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,2DAA2D;IAC3D,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,YAAY;QACZ,UAAU;QACV,SAAS;IACb;IACA;QACI,iBAAiB;QACjB,SAAS;QACT,UAAU;IACd;IACA;QACI,UAAU;QACV,SAAS;QACT,MAAM;IACV;IACA;QACI,UAAU;QACV,SAAS;QACT,WAAW;IACf;AACJ","sourcesContent":[".askai_maindiv {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    /* padding: 2rem;\r\n    margin: 4rem; */\r\n    /* background: #031B34;\r\n    background: -moz-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);\r\n    background: -webkit-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);\r\n    background: -o-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);\r\n    background: -ms-radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);\r\n    background: radial-gradient(circle at 30% -100%, #042c54 25%, rgba(4, 44, 84, 1) 85%, rgba(27, 120, 222, 1) 100%);\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); */\r\n}\r\n\r\n/* Chat start*/\r\n.chat_container {\r\n    width: 100%;\r\n    /* overflow-y: auto; */\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* align-items: center; */\r\n    max-height: 100%;\r\n    /* background-color: white; */\r\n}\r\n.ai_send_btn {\r\n    transition: 1s ease-out;\r\n\r\n\r\n}\r\n\r\n.ai_send_btn:hover {\r\n    color: rgb(96, 96, 235);\r\n    scale: 0.8;\r\n}\r\n\r\n\r\n.userBG {\r\n    /* background: linear-gradient(89.97deg, #ff803b 1.84%, #7523ce 90.67%); */\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    background: none;\r\n}\r\n\r\n.chatgptBG {\r\n    background: #053e7a;\r\n}\r\n\r\n.askai_chat_img {\r\n\r\n    /* border-radius: 50%; */\r\n}\r\n\r\n.askai_chat_img img {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n}\r\n\r\n.askai_chat_desc {\r\n    /* display: flex;\r\n    align-items:end; */\r\n    /* padding: 5px 0 0 0; */\r\n    /* padding-top: 10px; */\r\n}\r\n\r\n.askai_chat_desc p {\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    color: #fff;\r\n    margin-top: 20px;\r\n    /* padding: 6px; */\r\n}\r\n\r\n/* For WebKit browsers (Chrome, Safari) */\r\n\r\n\r\n\r\n\r\n\r\n/* chat end */\r\n\r\n\r\n/* Typing container styling */\r\n/* .typing-container {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    background: #031B34;\r\n    border-top: 1px solid rgb(48, 50, 68);\r\n} */\r\n\r\n.typing-content {\r\n    padding: 20px 10px;\r\n    /* margin: 0 2rem; */\r\n}\r\n\r\n/* .typing-textarea {\r\n    width: 100%;\r\n    display: flex;\r\n} */\r\n\r\n/* .typing-textarea {\r\n    resize: none;\r\n    height: auto;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    color: #FFFFFF;\r\n    font-size: 1rem;\r\n    border-radius: 4px;\r\n    max-height: 250px;\r\n    overflow-y: auto;\r\n    background: #053e7a;\r\n    outline: 1px solid #053e7a;\r\n} */\r\n\r\n/* .textarea_form {\r\n    width: 100%;\r\n} */\r\n\r\n/* .typing-textarea textarea::placeholder {\r\n    color: #dcdcdc;\r\n} */\r\n\r\n.ai_parent {\r\n    /* border-top-right-radius: 50%;\r\n    border-bottom-left-radius: 50%; */\r\n    border-radius: 30px 0 30px 0;\r\n    border: .1rem solid rgb(255, 255, 255);\r\n}\r\n\r\n.ai_parent>::-webkit-scrollbar {\r\n    width: 6px;\r\n    /* Adjust to your preferred width */\r\n\r\n}\r\n\r\n.ai_parent>::-webkit-scrollbar-thumb {\r\n    background: #6db4ff;\r\n\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.typing-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    /* font-size: 1.4rem; */\r\n    background: #053e7a;\r\n    /* outline: 1px solid #053e7a; */\r\n    cursor: pointer;\r\n}\r\n\r\n.typing-controls span:hover {\r\n    background: #053e7a;\r\n    color: #dcdcdc;\r\n}\r\n\r\n/* Reponsive Media Query */\r\n@media screen and (max-width: 600px) {\r\n    .typing-container {\r\n        padding: 15px 10px;\r\n    }\r\n\r\n    /* .typing-textarea textarea {\r\n        height: 45px;\r\n        padding: 10px 40px 10px 10px;\r\n    } */\r\n\r\n\r\n\r\n    span.material-symbols-rounded {\r\n        font-size: 1.25rem !important;\r\n    }\r\n}\r\n\r\n\r\n\r\n/* Typing Animation */\r\n.chat-bubble {\r\n    background-color: #E6F8F1;\r\n    padding: 16px 28px;\r\n    -webkit-border-radius: 20px;\r\n    -webkit-border-bottom-left-radius: 2px;\r\n    -moz-border-radius: 20px;\r\n    -moz-border-radius-bottomleft: 2px;\r\n    border-radius: 20px;\r\n    border-bottom-left-radius: 2px;\r\n    display: inline-block;\r\n}\r\n\r\n.typing {\r\n    align-items: center;\r\n    display: flex;\r\n    height: 17px;\r\n}\r\n\r\n.typing .dot {\r\n    animation: mercuryTypingAnimation 1.8s infinite ease-in-out;\r\n    background-color: #FFFFFF;\r\n    border-radius: 50%;\r\n    height: 7px;\r\n    margin-right: 4px;\r\n    vertical-align: middle;\r\n    width: 7px;\r\n    display: inline-block;\r\n}\r\n\r\n.typing .dot:nth-child(1) {\r\n    animation-delay: 200ms;\r\n}\r\n\r\n.typing .dot:nth-child(2) {\r\n    animation-delay: 300ms;\r\n}\r\n\r\n.typing .dot:nth-child(3) {\r\n    animation-delay: 400ms;\r\n}\r\n\r\n.typing .dot:last-child {\r\n    margin-right: 0;\r\n}\r\n\r\n@keyframes mercuryTypingAnimation {\r\n    0% {\r\n        transform: translateY(0px);\r\n        background-color: #053e7a;\r\n    }\r\n\r\n    28% {\r\n        transform: translateY(-7px);\r\n        background-color: #053e7a;\r\n    }\r\n\r\n    44% {\r\n        transform: translateY(0px);\r\n        background-color: #053e7a;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 600px) {\r\n    .askai_maindiv {\r\n        height: 100%;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n    .chat_container {\r\n        max-height: 100px;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n    .askai_chat{\r\n        padding: 0;\r\n        margin: 0;\r\n        gap: 0;\r\n    }\r\n    .typing-content{\r\n        padding: 0;\r\n        margin: 0;\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
